import React, { Component } from 'react'
import { func, string, bool, any } from 'prop-types'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import { translate } from 'react-i18next'

import { DisponibilityRadio } from './DisponibilityRadio'
import { isNotEmpty } from '../../../utilities/validators'

import 'react-datepicker/dist/react-datepicker.css'

/**
 *
 * Customized date picker component
 *
 */
const CustomDatePickerComponent = ({ t, onClick, value }) => (
  <div className='demande-form__disponibilites__date' onClick={onClick}>
    { value || t('common:buttons:select_date') }
  </div>
)

CustomDatePickerComponent.propTypes = {
  t: func,
  onClick: func,
  value: string
}
const CustomDatePicker = translate()(CustomDatePickerComponent)

/**
 *
 * Disponibility component
 *
 */

export class Disponibility extends Component {
  constructor ({ date, daytime }) {
    super()

    this.state = {
      date: date ? moment(date) : '',
      daytime: daytime || '',
      errors: [],
      isValid: false,
      validating: false
    }
  }

  componentWillReceiveProps ({ date, daytime }) {
    this.setState({ date: date ? moment(date) : null, daytime })
  }

  validate () {
    let isValid = true
    let errors = []
    if (this.props.required) {
      isValid = isNotEmpty(this.state.date) && isNotEmpty(this.state.daytime)
      errors.push({ message: 'Ce champ est obligatoire !' })
    }
    return { isValid, errors }
  }

  handleChange (name, value) {
    const update = {}
    update[name] = value
    this.setState(update)

    if (this.props.onChange) {
      this.props.onChange(name, value)
    }

    clearTimeout(this._rulesValidationTimeout)
    this._rulesValidationTimeout = setTimeout(() => {
      this.setState({ ...this.handleValidation() })
    }, 500)
  }

  handleValidation () {
    const result = this.validate()
    this.setState({ ...this.state, ...result })
    return { label: this.props.label, ...result }
  }

  render () {
    return (
      <div className='demande-form__disponibilites__dispo'>
        <DatePicker
          customInput={<CustomDatePicker />}
          selected={this.state.date}
          onChange={(value) => this.handleChange('date', value)}
          popoverTargetAttachment='bottom center'
          popoverTargetOffset='10px -50px'
          minDate={moment().add(1, 'days')} />
        <div className='demande-form__disponibilites__dispo__daytime'>
          <DisponibilityRadio name={this.props.name} value={this.state.daytime} onChange={(value) => this.handleChange('daytime', value)} />
        </div>
      </div>
    )
  }
}

Disponibility.propTypes = {
  name: string,
  label: string,
  onChange: func,
  required: bool,
  date: any,
  daytime: string
}



// WEBPACK FOOTER //
// ./src/components/ui/inputs/Disponibility.js